import React from "react";
import Colors from "../constants/Colors";

// Unified on/off toggle — the pill style from the recurring rule editor's
// "Set due date" switch. Use this for every boolean setting so the toggle UI
// is consistent across the app (replaces ad-hoc checkboxes / knob switches).
const ToggleSwitch = ({
  checked,
  onChange,
  onLabel = "On",
  offLabel = "Off",
  style,
}) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    onClick={() => onChange(!checked)}
    style={{ ...(checked ? styles.on : styles.off), ...style }}
  >
    {checked ? onLabel : offLabel}
  </button>
);

const pill = {
  padding: "8px 18px",
  borderRadius: "16px",
  cursor: "pointer",
  fontSize: "13px",
  fontWeight: 600,
  minWidth: "56px",
  textAlign: "center",
  boxSizing: "border-box",
  flexShrink: 0,
};

const styles = {
  off: {
    ...pill,
    border: "1px solid var(--border)",
    background: "transparent",
    color: "var(--text)",
  },
  on: {
    ...pill,
    border: `1px solid ${Colors.primary}`,
    background: Colors.primary,
    color: "#fff",
  },
};

export default ToggleSwitch;
